<template>
  <v-snackbar
    v-model="show"
    :timeout="-1"
    color="primary"
    top
    multi-line
  >
    <div class="d-flex align-center">
      <v-icon left dark>mdi-cellphone</v-icon>
      <div>
        <strong>Install Codelyzer</strong><br>
        <span class="text-caption">Install as app for offline use</span>
      </div>
    </div>
    
    <template v-slot:action="{ attrs }">
      <v-btn
        text
        dark
        v-bind="attrs"
        @click="installApp"
        class="mr-2"
        :loading="installing"
      >
        Install
      </v-btn>
      <v-btn
        icon
        dark
        v-bind="attrs"
        @click="dismiss"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import pwaService from '@/services/pwaService';

export default {
  name: 'InstallPrompt',
  
  data() {
    return {
      show: false,
      dismissed: false,
      installing: false,
      mounted: false
    };
  },
  
  mounted() {
    this.mounted = true;
    
    // Check if already installed
    if (pwaService.checkIfInstalled()) {
      console.log('Already installed, not showing prompt');
      return;
    }
    
    // Listen for install ready events
    pwaService.onInstallReady(this.checkAndShow);
    
    // Also check immediately
    this.checkAndShow();
    
    // Check for dismissed preference
    this.checkDismissed();
  },
  
  methods: {
    checkAndShow() {
      if (!this.mounted) return;
      
      if (pwaService.isInstallable() && !this.dismissed) {
        console.log('Install is ready, showing prompt');
        this.show = true;
      } else {
        console.log('Install not ready or dismissed', {
          isInstallable: pwaService.isInstallable(),
          dismissed: this.dismissed
        });
      }
    },
    
    checkDismissed() {
      const lastDismissed = localStorage.getItem('installPromptDismissed');
      if (lastDismissed) {
        const daysSinceDismissed = (Date.now() - parseInt(lastDismissed)) / (1000 * 60 * 60 * 24);
        if (daysSinceDismissed < 7) {
          console.log('Install prompt dismissed recently, not showing');
          this.dismissed = true;
        }
      }
    },
    
    async installApp() {
      this.installing = true;
      
      try {
        const installed = await pwaService.install();
        if (installed) {
          this.show = false;
          this.$emit('installed');
        }
      } catch (error) {
        console.error('Install failed:', error);
        // Fallback to instructions
        this.showInstallInstructions();
      } finally {
        this.installing = false;
      }
    },
    
    showInstallInstructions() {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isAndroid = /Android/.test(navigator.userAgent);
      
      let message = '';
      if (isIOS) {
        message = '📱 On iOS: Tap Share → Add to Home Screen';
      } else if (isAndroid) {
        message = '📱 On Android: Tap Menu → Install App';
      } else {
        message = '💻 On desktop: Click install icon in address bar';
      }
      
      this.$emit('show-instructions', message);
      this.show = false;
    },
    
    dismiss() {
      this.show = false;
      this.dismissed = true;
      localStorage.setItem('installPromptDismissed', Date.now().toString());
      this.$emit('dismissed');
    }
  }
};
</script>